module.exports = __webpack_public_path__ + "img/v4_adminRole_h.c6cb7246.png";